import { render, staticRenderFns } from "./OverviewCard.vue?vue&type=template&id=5520bc45&scoped=true"
import script from "./OverviewCard.vue?vue&type=script&lang=js"
export * from "./OverviewCard.vue?vue&type=script&lang=js"
import style0 from "./OverviewCard.vue?vue&type=style&index=0&id=5520bc45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5520bc45",
  null
  
)

export default component.exports